import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth, initAuth, getToken } from '../utils/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUser = async () => {
      const token = getToken();
      if (token) {
        initAuth();
        try {
          const userData = await auth.getMe();
          setUser(userData);
          if (userData.admin_path) localStorage.setItem('admin_path', userData.admin_path);
        } catch (error) {
          console.error('Failed to load user', error);
          auth.logout();
        }
      }
      setLoading(false);
    };
    loadUser();
  }, []);

  const login = async (email, password) => {
    const data = await auth.login(email, password);
    // If 2FA required, don't set user yet - Login.js handles the flow
    if (data.requires_2fa || data.requires_2fa_setup) {
      return data;
    }
    setUser(data.user);
    return data;
  };

  const register = async (email, password, name) => {
    const data = await auth.register(email, password, name);
    setUser(data.user);
    return data;
  };

  const logout = () => {
    auth.logout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);